<template>
  <button expand="block" color="secondary" class="button-purple button-icon button-icon-chat mt-4 mb-6" @click="$router.push('contact')" data-cy="profile-button-contact">
    <span class="block capitalize text-white text-[14px] font-semibold height-[60px]">Contact Us to Update Details</span>
  </button>
  <hr />
  <button class="button-underline button-underline-grey mt-6 mb-12 flex items-center" @click="$router.push('close-account')" data-cy="profile-button-close">
    <span class="capitalize text-[14px] height-[40px] font-bold ion-text-grey underline mr-2">Close Account Permanently</span> 
    <ion-icon src="/assets/general/notice-grey.svg" class="w-[18px] h-[18px]"></ion-icon>
  </button>
</template>